import { useLogout as useXsLogout } from "@xinosolutions/xs-auth-react";
import { useProductMember } from "../context/ProductContext";
import { clearCsrfToken } from "../bl_libs/invokeApi";
import { useContentSetting } from "./ContentSetting";

/**
 * XS Auth sign-out + clear product/workspace state.
 */
export function useAdminLogout({ homePath = "/" } = {}) {
  const { clearProduct } = useProductMember();
  const { STOP_SOCKET_FORCEFULLY, setUserInfo } = useContentSetting();

  const { signOut, pending } = useXsLogout({
    homePath,
    onRevokedAll: () => {
      STOP_SOCKET_FORCEFULLY();
      clearCsrfToken();
      setUserInfo({});
      clearProduct();
    },
  });

  return { logout: signOut, signOut, pending };
}
